import { MAT_DATE_FORMATS } from "@angular/material/core";
import { Component, ElementRef, OnInit, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageBase } from 't4core';
import { CostInfo, CostType, CustomerInfo, PaymentRequestInfo, PaymentRequestStatus } from "t4core";
import { transform } from "typescript";
import { Console } from "console";
import { FormControl } from "@angular/forms";
import { clearLine } from "readline";


@Pipe({ name: 'paymentRequestStatus' })
export class PaymentRequestStatusPipe implements PipeTransform {
  transform(value: number): string {
    return PaymentRequestStatus[value];
  }
}

@Component({
  styleUrls: ['./paymentrequests.component.css'],
  selector: 'paymentrequests',
  templateUrl: './paymentrequests.component.html',
})
export class PaymentRequestsComponent extends PageBase implements OnInit {

  public paymentRequests: PaymentRequestInfo[];
  public paymentRequestsCopy: PaymentRequestInfo[];
  public costRequests: CostInfo[];

  public PaymentReqStatus: any[];

  public updateRequests: any;
  public Expired: boolean = false;

  private _from: moment.Moment = this.now.clone().startOf('month').add(-1, 'month');
  private _to: moment.Moment = this.now.clone();
  public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };

  public filterGroups: any[] = [];
  public groupsControl = new FormControl([]);

  public get from(): moment.Moment { return this._from; }
  public set from(val: moment.Moment) {
    if (this._from != val) {
      this._from = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "RentalReport" };
    }
  }

  public get to(): moment.Moment { return this._to; }
  public set to(val: moment.Moment) {
    if (this._to != val) {
      this._to = val;
      this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "Paymentrequests" };
    }
  }

  public updateParams() {
    this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]"), reportName: "Paymentrequests" };
    this.GetPaymentsList();
    this.GetCostList();
  }

  constructor(el: ElementRef) {
    super(el, "PaymentRequests");
  }

  public async ngOnInit() {
    this.GetPaymentsList();
    this.GetCostList();
    this.GetReqStatus();
    this.GetStatus();
  }

  public async GetPaymentsList() {
    this.paymentRequests = await this.Api.get<PaymentRequestInfo[]>("RentalService/GetPaymentRequestsList", { from: this.from, to: this.to });
    this.paymentRequestsCopy = this.paymentRequests;
  }

  public async GetCostList() {
    this.costRequests = await this.Api.get<CostInfo[]>("RentalService/GetCostList", { from: this.from, to: this.to });
  }

  public async GetReqStatus() {
    this.PaymentReqStatus = Object.keys(PaymentRequestStatus).filter((item) => {
      return isNaN(Number(item));
    });
  }

  public applyFilter() {
    const selectedGroups = this.groupsControl.value;

    this.filterData(selectedGroups);
  }

  public filterData(selectedGroups: number[]) {

    if (selectedGroups == null || selectedGroups.length < 1)
      this.paymentRequests = this.paymentRequestsCopy;
    
    var result: PaymentRequestInfo[]= [];

    selectedGroups.forEach((element) => {
      var elementString = PaymentRequestStatus[element];

      var addArray = new Array<PaymentRequestInfo>();
      this.paymentRequestsCopy.
        filter(f => f.Status == element).
        map(m => result.push(m));
    });

    this.paymentRequests = result;
  }

  public async updateRequestsList() {
    var token = this.UI.beginLoading("T4.Bookings.paymentrequests.Payments", "Loading Payments", null);
    if (this.Expired) {
      this.GetPaymentsList();
    }
    else {
     //  this.paymentRequests = await this.Api.get<PaymentRequestInfo[]>("RentalService/GetFiltedPaymentRequestsList", PaymentRequestStatus.Expired);
    }
    console.log("PaymentRequests..");
    this.UI.loaderCompleted(token);
  }

  public async invoised(rentalId) {
    var message = await this.UI.prompt("Turbo.Core.RentalDialog.ManuallyRequest2", "Set status to manually Invoiced", "Turbo.Core.RentalDialog.msgAddCommentAnnata", "Add invoice number from Annata");

    if (message != null) {

      message = "RentalId:" + rentalId +" Annata:" + message;
    
      await this.Api.get<PaymentRequestInfo>("RentalService/UpdatePaymentRequest", { rentalId: rentalId });
      await this.Api.post<CustomerInfo>("RentalService/RentalEvent", null, { rentalId: rentalId, type: 0, message: message });

      this.GetPaymentsList();
    }
} 

  private GetStatus() {
    this.filterGroups.push({ Id: 0, Text: "Created" });
    this.filterGroups.push({ Id: 10, Text: "Pending" });
    this.filterGroups.push({ Id: 50, Text: "Expired" });
    this.filterGroups.push({ Id: 100, Text: "Completed" });
    this.filterGroups.push({ Id: 101, Text: "Canceled" });
    this.filterGroups.push({ Id: 150, Text: "ManuallyInvoiced" });
  }
}
